

require("../Foundation/stylable/colors.st.css.js");
require("../Foundation/stylable/typography.st.css.js");
const { classesRuntime, statesRuntime } = require("./../stylable-cjs-runtime.js");



var _namespace_ = "wds_1_146_2_Heading";
var _style_ = classesRuntime.bind(null, _namespace_);

module.exports.cssStates = statesRuntime.bind(null, _namespace_);
module.exports.style = _style_;
module.exports.st = _style_;

module.exports.namespace = _namespace_;
module.exports.classes = {"root":"wds_1_146_2_Heading__root","heading-h1":"wds_1_146_2_StylableTypography__heading-h1","heading-h2":"wds_1_146_2_StylableTypography__heading-h2","heading-h3":"wds_1_146_2_StylableTypography__heading-h3","heading-h4":"wds_1_146_2_StylableTypography__heading-h4","heading-h5":"wds_1_146_2_StylableTypography__heading-h5","heading-h6":"wds_1_146_2_StylableTypography__heading-h6","heading-xl":"wds_1_146_2_StylableTypography__heading-xl","heading-l":"wds_1_146_2_StylableTypography__heading-l","heading-m":"wds_1_146_2_StylableTypography__heading-m","heading-s":"wds_1_146_2_StylableTypography__heading-s","heading-t":"wds_1_146_2_StylableTypography__heading-t","heading-xt":"wds_1_146_2_StylableTypography__heading-xt"};
module.exports.keyframes = {}; 
module.exports.layers = {};
module.exports.containers = {};
module.exports.stVars = {}; 
module.exports.vars = {"wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-color-text-standard-secondary":"--wds-color-text-standard-secondary","wds-font-letter-spacing-heading-5":"--wds-font-letter-spacing-heading-5","wds-font-letter-spacing-heading-6":"--wds-font-letter-spacing-heading-6"}; 




